/**
 * Apartsales — Главная (Tab 1).
 *
 * Одна витринная карточка одного канонического юнита («Морской бриз»).
 * Тап в центр фото → переход на SEO-friendly slug-URL (§2.4 ТЗ):
 *   /russia/sochi/ug-development/morskoi-briz/unit/a-08-101
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';

import { UnitCard } from '~/components/UnitCard';
import { fetchUnitCard } from '~/lib/unit-card-api';
import { unitCardToProperty } from '~/lib/unit-card-adapter';
import { buildSlugUrl } from '~/lib/slug-routing';

// Канонический UUID Морского бриза (см. infra/supabase/seeds/morskoy_briz.sql)
const CANONICAL_UNIT_ID = '99999999-cccc-cccc-cccc-000000000001';

export const Route = createFileRoute('/')({
  component: HomeScreen,
});

function HomeScreen() {
  const navigate = useNavigate();
  const { data, isLoading, error } = useQuery({
    queryKey: ['unit-card', CANONICAL_UNIT_ID],
    queryFn: () => fetchUnitCard(CANONICAL_UNIT_ID),
    staleTime: 60_000,
  });

  if (isLoading) {
    return (
      <div className="px-4 py-4">
        <div className="aspect-[4/5] w-full animate-pulse rounded-[20px] bg-bg-3" />
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="px-4 py-8 text-center">
        <div className="text-[14px] text-label-2">Не удалось загрузить карточку</div>
        {error && (
          <div className="mt-2 text-[11px] text-label-3">{(error as Error).message}</div>
        )}
      </div>
    );
  }

  const property = unitCardToProperty(data);
  const slugUrl = buildSlugUrl(data);

  return (
    <div className="px-4 py-4">
      <UnitCard
        property={property}
        onOpen={() => navigate({ to: slugUrl })}
      />
    </div>
  );
}
/* bump 1778961342 */
/* bump 1778969092 */
/* bump 1779003725 */
/* bump 1779004070 */
/* bump 1779026560 */
/* bump 1779029077 */
/* bump 1779029948 */
/* bump 1779031256 */
/* bump 1779031727 */
/* deploy bump 1779032326 */
/* bump 1779033041 */
/* bump 1779033340 */
/* bump 1779033557 */
/* bump 1779043781 */
/* deploy bump 1779046152 */
/* deploy bump 1779046189 */
/* deploy bump 1779047050 */
/* bump 1779047366 */
/* bump 1779088560 */
/* bump 1779088766 */
/* deploy bump 1779088977 */
/* bump 1779178388 */
/* deploy bump 1779180737 */
/* bump 1779181388 */
/* deploy bump 1779182731 */
/* deploy bump 1779183617 — bdc4cd8 TourTab */
/* bump 1779187518 */
/* deploy bump 1779187746 */
/* bump 1779219656 */
/* bump 1779220454 */
/* bump 1779224864 */
/* bump 1779226255 */
/* bump 1779226805 */
/* deploy bump 1779282225 — force CF Pages rebuild (reviews tab) */
/* deploy bump 1779283443 — force CF Pages rebuild (location tab) */
/* deploy bump 1779284530 — force CF Pages rebuild (money tab) */
/* deploy bump 1779284956 — money-api array-unwrap fix */
/* deploy bump 1779285402 — money tab cache-bust */
/* deploy retry 1779285505 */
/* deploy bump 1779350240 — sticky bg cache-bust */
/* deploy bump 1779357257 */
/* bump 1779452061 */
/* bump 1779457893 */
/* redeploy bump 1779647257 */
/* redeploy bump 1779697820 */
